<template>
  <a-icon :component="CloseIcon" />
</template>

<script>
const CloseIcon = {
  template: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM14.9029 7.75727C15.2728 7.3873 15.8727 7.3873 16.2426 7.75727C16.6126 8.12724 16.6126 8.72708 16.2426 9.09705L13.3398 11.9999L16.2427 14.9029C16.6126 15.2728 16.6126 15.8727 16.2427 16.2426C15.8727 16.6126 15.2729 16.6126 14.9029 16.2426L12 13.3397L9.09715 16.2426C8.72717 16.6125 8.12733 16.6125 7.75736 16.2426C7.38739 15.8726 7.38739 15.2727 7.75736 14.9028L10.6602 11.9999L7.75739 9.09714C7.38742 8.72717 7.38742 8.12733 7.75739 7.75736C8.12736 7.38739 8.7272 7.38739 9.09717 7.75736L12 10.6602L14.9029 7.75727Z" fill="#9A9B9C"/>
    </svg>
  `
};

export default {
  data() {
    return {
      CloseIcon
    };
  }
};
</script>

<style></style>
